import { FC, ReactNode } from "react"

import { STATS_CHART_COLORS } from "../chart-with-stats/palette"

interface GradientProgressRowProps {
  label: ReactNode
  count: number
  maxCount: number
  netPercentage?: string
  isPositive?: boolean
  isActive?: boolean
  onClick?: () => void
  color?: string
}

const GradientProgressRow: FC<GradientProgressRowProps> = ({
  label,
  count,
  maxCount,
  netPercentage,
  isPositive,
  isActive,
  onClick,
  color = STATS_CHART_COLORS.purple
}) => {
  const widthPercentage = maxCount ? Math.min((count / maxCount) * 100, 100) : 0

  return (
    <div
      className={`flex min-w-0 flex-col rounded-lg transition-colors ${
        onClick
          ? `cursor-pointer p-2 -m-2 ${
              isActive ? "bg-purple-50" : "hover:bg-purple-50"
            }`
          : ""
      }`}
      onClick={onClick}
    >
      <div className="flex items-center justify-between gap-3">
        <div className="flex min-w-0 items-center gap-2 text-sm font-medium text-slate-900">
          <span
            className="h-2 w-2 shrink-0 rounded-full"
            style={{ backgroundColor: color }}
          />
          <span className="truncate">{label}</span>
        </div>
        <div className="flex shrink-0 items-center gap-2">
          <span className="text-sm font-semibold text-slate-900">
            {count?.toLocaleString("en-US")}
          </span>
          {netPercentage && (
            <span
              className={`rounded-full px-2 py-0.5 text-xs font-semibold ${
                isPositive
                  ? "bg-green-50 text-green-600"
                  : "bg-rose-50 text-rose-600"
              }`}
            >
              {netPercentage}
            </span>
          )}
        </div>
      </div>
      <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-slate-100">
        <div
          className="h-full rounded-full transition-all duration-300"
          style={{
            width: `${widthPercentage <= 0 ? 0 : widthPercentage}%`,
            backgroundImage: `linear-gradient(90deg, #ABA3FF 0%, ${color} 100%)`
          }}
        />
      </div>
    </div>
  )
}

export default GradientProgressRow
